import { useEffect, useState }  from 'react'
import { useFocusGet, useAtom, useGet } from 'state/jotai'

import { _bootstrap }           from 'state/store.bootstrap'
import { _project }             from 'state/store.projects'
import { _isometry }            from 'state/store.isometry'
import { _subiso }              from 'state/store.subiso'

import { array } from 'utilities/utility.misc'
import { _seasons_isometry } from 'state/store.season'
import { getIsoData, getSeasonIsoData } from 'state/jotai.isometryDataHooks'
import { ISOPARENT_CONFIG, SEASON_ISO_CONFIG } from 'api/api'
import { useFetch } from './fetch/useFetch'
import { _parentIsometry } from 'state/store.parentIsometry'
import { isParentIsometryAvailable } from 'state/store.global'

export const useProjectSetup = () => {

  const [ res, setRes ] = useState(false)
  
  const [ isometry, setIsometry ] = useAtom(_isometry)
  const setParentIsoAvl                                      = useAtom(isParentIsometryAvailable)[1]
  const [ parentIsometry, setParentIsometry ]             = useAtom(_parentIsometry)
  const [ project , setProject  ] = useAtom(_project)
  const [ subiso  , setSubiso   ] = useAtom(_subiso)
  const [ seassonIsometry, setSeassonIsometry ]           = useAtom(_seasons_isometry)
  const url    = SEASON_ISO_CONFIG
  const config = useFetch({ url, file: '' }).D

  const parentUrl    = ISOPARENT_CONFIG
  const parentConfig = useFetch({ url: parentUrl, file: '' }).D

  const _x = {}
  const _y = {}
  const _z = {}
  let _zy = {}
  const _u = {}
  
  const ARR = useFocusGet(_bootstrap, 'projectids')
 
  const NUM = ARR?.length || 0
  const BAS = array(NUM, x => ({ [ARR[x]]:[] }) )

  useEffect(()=>{
   
    if ( BAS.length > 0 ) {
      
      Object.keys(isometry).forEach( x => _x[x] = BAS )
      Object.keys(project ).forEach( y => _y[y] = BAS )
      Object.keys(subiso  ).forEach( z => _z[z] = BAS )
      
      setIsometry(_x)
      setProject (_y)
      setSubiso  (_z)

      setRes(true)

    }
  },[ARR])

  // useEffect(()=> {

  //   if(config && ARR) {
  //     const new_zy = {}
  //     const seasons = ['fall', 'summer', 'winter', 'spring']

  //     let angleType = {}
  //     const frame = {}
  //     const SEASONBAS = array(NUM, x => {
  //       const frames = {}

  //       config[x]?.IMAGE_SNAPFRAMES?.forEach((i_s) => {
  //         frames[i_s] = [];
  //         frame[i_s] = {};

  //         // setting active frame for sun animation isometry
  //         seasons.forEach((s) => {
  //           frame[i_s][s] = config[x]?.SEASONS?.[i_s]?.[s]?.FIRST_IMAGE
  //         }) 

  //         angleType   = {
  //           ...angleType,
  //           [i_s]: {type : "summer"}
  //         }
  //       })
  //       return { [ARR[x]]: frames }
  //     } )
  //     Object.keys(seassonIsometry ?? {}).forEach( zy => _zy[zy] = SEASONBAS )

  
  //     ARR.forEach((pid, pin) => {
  //       if (!new_zy.season_type) new_zy.season_type = [];
  //       if (!new_zy.activeframe) new_zy.activeframe = [];

  //       new_zy.season_type.push({[pid]: angleType})
  //       new_zy.activeframe.push({[pid]: frame})
  //     })

  //     _zy = {
  //       ..._zy,
  //       ...new_zy
  //     }
 
     
  //     setSeassonIsometry(_zy)
  //   }
  // }, [ARR, config])

  useEffect(()=>{
     if(BAS.length > 0 && parentConfig) {
    let _BAS = []
    
       Object.keys(parentIsometry).forEach( u => {
        if(u === "toggle"){
          
          BAS.forEach((b, i) => {
            if((Object.keys(b) || {}).length > 0) {
              if(parentConfig[i]) {
                 _BAS[i] = {
                  [Object.keys(b)[0]]: false
                }
              }else {
                  _BAS[i] = {
                [Object.keys(b)[0]]: false
              }
              }
            
            }
          })
          return _u[u] = _BAS
        }
        return _u[u] = BAS
      } )
    
      setParentIsometry(_u)
      setParentIsoAvl(_BAS)
     }
  }, [ARR, parentConfig])
  
  return { res }
  
}